import { PxdAgDatePickerEditorComponent } from '@app/shared/aggrid/pxd-ag-grid-datepicker-editor';
import { PxdAgGridNumericEditorComponent } from '@app/shared/aggrid/pxd-ag-grid-numeric-editor';
import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridExcelStyles, PxdAgGridFilterParams, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions, PXDDefaultExcelExportParams } from '@app/shared/aggrid/pxd-ag-grid-options';
import { GridApi } from 'ag-grid-community';
import dayjs from 'dayjs';

export class SurfaceDevScheduleTaskGridOptions {

  public isAllowedToEditSchedule = false;

  dateComparator(date1: any, date2: any) {
    const date1Value = new Date(date1);
    const date2Value = new Date(date2);

    if (date1Value < date2Value) {
      return -1;
    } else if (date1Value > date2Value) {
      return 1;
    } else {
      return 0;
    }
  }

  private editable(params): boolean {
    return params.data && params.data.Readonly == false;
  }

  private cellClass(params): string {
    return !params.data || params.data.Readonly == true ? 'readonlycell' : '';
  }

  public async setDefaultFilter(api: GridApi) {
    await api.setColumnFilterModel('Phase', { values: ['CONSTRUCT'] });
    api.onFilterChanged();
  }

  public gridOptions: PxdAgGridOptions = {
    tooltipShowDelay: 0,
    enableCharts: true,
    cellSelection: true,
    rowGroupPanelShow: 'always',
    defaultColDef: PxdAgEditGridDefaultColumnDef,
    statusBar: PxdAgGridStatusBarOptions,
    sideBar: PxdAgGridSideBarOptions,
    columnTypes: PxdAgGridColumnTypes,
    excelStyles: PxdAgGridExcelStyles,
    defaultExcelExportParams: PXDDefaultExcelExportParams,
    columnDefs: [
      {
        field: 'SortOrder', headerName: 'Id', flex: 1, editable: false, cellClass: 'readonlycell', width: 75, hide: true
      },
      {
        field: 'Phase', headerName: 'Phase', flex: 1, editable: false, cellClass: 'readonlycell'
      },
      {
        field: 'Step', headerName: 'Step', flex: 1, editable: false, cellClass: 'readonlycell'
      },
      {
        field: 'Predecessor', headerName: 'Predecessor', flex: 1, editable: false, cellClass: 'readonlycell'
      },
      {
        field: 'Lag', headerName: 'Lag', flex: 1, editable: false, cellClass: 'readonlycell', width: 75
      },

      {
        field: 'PlannedDurationDays',
        headerName: 'Planned Duration',
        editable: (params) => this.editable(params),
        cellClass: (params) => this.cellClass(params),

        valueFormatter: params => (+params.value).toFixed(2),
        valueGetter: params => {
          return params.data.PlannedDurationDays
        },
        valueSetter: params => {
          params.data.PlannedDurationDays = Number(params.newValue);
          return true;
        },

        aggFunc: 'sum',
        headerTooltip: 'PlannedDuration (days)',
        type: ['numberColumn'],
        flex: 1,
        cellEditorSelector: params => {
          return {
            component: PxdAgGridNumericEditorComponent,
          }
        },
      },
      {
        //TODO: use a kendo DateTimePicker cell editor 
        field: 'PlannedStart',
        headerName: 'Planned Start',
        type: ['dateColumn'],
        flex: 1,
        editable: (params) => this.editable(params),
        cellClass: (params) => this.cellClass(params),
        comparator: this.dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: PxdAgGridFilterParams.customDate,
        cellEditorSelector: params => {
          return {
            component: PxdAgDatePickerEditorComponent,
            params: {
              minDate: dayjs("01/01/2000").toDate(),
              value: params.data.PlannedStart
            }
          }
        }
      },
      {
        field: 'PlannedFinish',
        headerName: 'Planned Finish',
        type: ['dateColumn'],
        flex: 1,
        editable: false,
        comparator: this.dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: PxdAgGridFilterParams.customDate,
        cellClass: 'readonlycell'
      },
      {
        field: 'ActualDurationDays',
        headerName: 'Actual Duration',
        type: ['numberColumn'],
        flex: 1,
        editable: false,
        valueFormatter: params => (+params.value).toFixed(2),
        aggFunc: 'sum',
        cellClass: 'readonlycell'

      },
      {
        field: 'ActualStart',
        headerName: 'Actual Start',
        type: ['dateColumn'],
        flex: 1,
        editable: (params) => this.editable(params),
        cellClass: (params) => this.cellClass(params),
        comparator: this.dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: PxdAgGridFilterParams.customDate,
        cellEditorSelector: params => {
          return {
            component: PxdAgDatePickerEditorComponent,
            params: {
              minDate: dayjs("01/01/2000").toDate(),
              value: params.data.ActualStart
            }
          }
        }
      },
      {
        field: 'ActualFinish',
        headerName: 'Actual Finish',
        type: ['dateColumn'],
        flex: 1,
        editable: (params) => this.editable(params),
        cellClass: (params) => this.cellClass(params),
        comparator: this.dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: PxdAgGridFilterParams.customDate,
        cellEditorSelector: params => {
          return {
            component: PxdAgDatePickerEditorComponent,
            params: {
              minDate: dayjs("01/01/2000").toDate(),
              value: params.data.ActualFinish
            }
          }
        }
      }
    ]
  };
}